module.exports = __webpack_public_path__ + "img/resumeweb.06b0ac4d.webp";